
import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/components/AuthProvider';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [shouldRedirect, setShouldRedirect] = useState(false);

  console.log('ProtectedRoute - user:', !!user, 'loading:', loading);

  useEffect(() => {
    if (!loading && !user) {
      // Small delay to prevent flash during auth state changes
      const timer = setTimeout(() => setShouldRedirect(true), 200);
      return () => clearTimeout(timer);
    } else if (!loading && user) {
      setShouldRedirect(false);
    }
  }, [loading, user]);

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
          <p className="mt-4 text-muted-foreground">Verifying authentication...</p>
        </div>
      </div>
    );
  }

  // Redirect to home page if not authenticated (where DualAuthModal is available)
  if (!user && shouldRedirect) {
    console.log('Redirecting to home - no user found');
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Show children if authenticated
  if (user) {
    return <>{children}</>;
  }

  // Default loading state while determining redirect
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
        <p className="mt-4 text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
};
